import { Box, Stack } from '@mui/material';
import useAuthForms from '../../../../hooks/useAuthForms';
import useDisplayContentConfig from '../../../../hooks/useDisplayContentConfig';
import useHandleSignUpParams from '../../../../hooks/useHandleSignUpParams';
import useLocalization from '../../../../hooks/useLocalization';
import SignInButton from '../../../atoms/SignInButton';
import DesktopHeaderFrame from './DesktopHeaderFrame';
import HeaderHomeLink from './HeaderHomeLink';
import { styles } from './Header.styles';
import NeobetRaisedActionButton from './NeobetRaisedActionButton';

const PublicRegisterButton = () => {
  const { t } = useLocalization();
  const { openRegisterForm } = useAuthForms();

  useHandleSignUpParams();

  return (
    <NeobetRaisedActionButton
      label={t('register.register')}
      visualVariant='header'
      onClick={() => openRegisterForm()}
    />
  );
};

const PublicAuthActions = () => {
  const { isEndUserMode } = useDisplayContentConfig();

  return (
    <Stack direction='row' sx={styles.publicAuthActions} data-testid='neobet-public-auth-actions'>
      <SignInButton sx={styles.publicSignInButton} />
      {isEndUserMode ? <PublicRegisterButton /> : null}
    </Stack>
  );
};

type PublicToolbarProps = {
  isMobile: boolean;
  isSidebarCompact: boolean;
  showSidebarCollapse: boolean;
  toggleSidebarCompact?: () => void;
};

const PublicToolbar = ({
  isMobile,
  isSidebarCompact,
  showSidebarCollapse,
  toggleSidebarCompact,
}: PublicToolbarProps) => {
  if (isMobile) {
    return (
      <Box sx={styles.publicToolbar} data-testid='neobet-public-mobile-topbar'>
        <HeaderHomeLink size='small' />
        <PublicAuthActions />
      </Box>
    );
  }

  return (
    <DesktopHeaderFrame
      isSidebarCompact={isSidebarCompact}
      showSidebarCollapse={showSidebarCollapse}
      sidebarSlotTestId='neobet-public-desktop-sidebar-slot'
      testId='neobet-public-desktop-topbar'
      toggleSidebarCompact={toggleSidebarCompact}
    >
      <HeaderHomeLink />
      <PublicAuthActions />
    </DesktopHeaderFrame>
  );
};

export default PublicToolbar;
